import React, { useState, useEffect } from 'react';

import moment from 'moment';

import { Modal, Radio } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';

import { toast } from 'react-toastify';

import RenderProfilePic from '../../../../../../extras/RenderProfilePic';

import { getCapstoneProjectScoreDetails } from '../../../../../../services/apiService';

const timeFormat = 'DD MMM YYYY hh:mm:ss a';

export default function ProjectScorePopup({
  score,
  projectId,
  goalType,
  studentId,
}) {
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [response, setResponse] = useState(null);

  const [feedbackRatingObj, setFeedbackRatingObj] = useState(null);
  const [rating, setRating] = useState([]);
  const [plaigarism, setPlaigarism] = useState('');
  const [feedbackText, setFeedbackText] = useState('');
  const [isIterateThroughRatingObj, setIsIterateThroughRatingObj] =
    useState(false);

  const handleClose = () => {
    setOpenModal(false);
  };

  const setRubricsMapping = (response) => {
    const allRubricsArr = response?.attributes?.projectCategory?.rubrics;

    setFeedbackText(response?.attributes?.coachFeedback?.feedback);

    const rubricsValue = response?.attributes?.coachFeedback?.ratings;

    if (!allRubricsArr) return;
    for (let i = 0; i < allRubricsArr?.length; i++) {
      const rubricItem = allRubricsArr[i];
      const rubricItemKey = rubricItem.rubricKey;
      if (rubricsValue && rubricsValue[rubricItemKey]) {
        rubricItem.value = rubricsValue[rubricItemKey];
      } else {
        setIsIterateThroughRatingObj(true);
        break;
      }
    }

    if (response?.attributes?.coachFeedback?.plagiarisedSolution) {
      setPlaigarism('plagiarised');
    } else {
      setPlaigarism('self_written');
    }

    setRating(allRubricsArr);
  };

  useEffect(async () => {
    if (openModal) {
      setLoading(true);
      try {
        const response = await getCapstoneProjectScoreDetails(
          projectId,
          goalType,
          studentId
        );
        setResponse(response);
        setFeedbackRatingObj(response?.attributes?.coachFeedback?.ratings);
        setRubricsMapping(response);
      } catch (err) {
        console.error(err);
        toast.error('Failed to fetch data');
      }
      setLoading(false);
    }
  }, [openModal]);

  return (
    <div>
      <div
        className='flex items-center h-full text-blue-600 cursor-pointer'
        onClick={() => {
          setOpenModal(true);
        }}
      >
        {score}
      </div>

      <Modal
        open={openModal}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <div className='relative overflow-y-auto h-5/6 top-2 md:top-10 m-auto bg-white  rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/2 w-11/12 border-solid border border-gray-600'>
          <div
            className='absolute right-2 top-2 cursor-pointer'
            onClick={handleClose}
          >
            X
          </div>
          {loading ? (
            <div className='flex justify-center'>Loading...</div>
          ) : (
            <div className='flex flex-col'>
              <div className='flex mb-4'>
                <RenderProfilePic
                  name={response?.attributes?.name}
                  thumbnail=''
                  size='3'
                />

                <div className='flex-auto'>
                  <div className='mr-2 px-4 flex items-center gap-3'>
                    <div className='flex-auto'>
                      <h3 className='font-medium'>
                        {response?.attributes?.name}
                      </h3>

                      <span className='text-gray-600 text-opacity-80 text-sm'>
                        {response?.attributes?.projectCategory?.name}
                      </span>
                    </div>
                    <div>
                      {response?.attributes?.submittedAt && (
                        <div className='text-gray-500 text-sm grow-0'>
                          Submitted on{' '}
                          {moment(response?.attributes?.submittedAt).format(
                            timeFormat
                          )}
                        </div>
                      )}
                      {response?.attributes?.evaluatedAt && (
                        <div className='text-gray-500 text-sm grow-0'>
                          Evaluated on{' '}
                          {moment(response?.attributes?.evaluatedAt).format(
                            timeFormat
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <hr className='mb-4' />
              <div className='font-bold'>Ratings & Feedback</div>

              {isIterateThroughRatingObj
                ? feedbackRatingObj &&
                  Object.keys(feedbackRatingObj).map((objectKey, index) => (
                    <div className='flex mb-2' key={index}>
                      <div className='w-64 text-gray-400 text-sm'>
                        {objectKey}
                      </div>
                      <Rating
                        max={10}
                        readOnly={true}
                        name={objectKey}
                        value={feedbackRatingObj[objectKey]}
                      />
                    </div>
                  ))
                : rating.map((rubricItem, index) => (
                    <div className='flex mb-2' key={index}>
                      <div className='w-64 text-gray-400 text-sm'>
                        {rubricItem.rubricName}
                      </div>
                      <Rating
                        max={10}
                        readOnly={true}
                        name={rubricItem.rubricName}
                        value={rubricItem.value}
                      />
                    </div>
                  ))}

              <hr className='mt-4 mb-4' />

              <div className='text-gray-400 text-sm'>Plaigarism</div>
              <div className='flex items-center -mb-2 -ml-2'>
                <Radio
                  disabled={true}
                  color='primary'
                  name='plaigarism'
                  value='self_written'
                  checked={plaigarism === 'self_written'}
                />
                <span className='text-sm font-normal opacity-60'>
                  Self-written submission
                </span>
              </div>
              <div className='flex items-center -mb-2 -ml-2'>
                <Radio
                  disabled={true}
                  color='primary'
                  name='plaigarism'
                  value='plagiarised'
                  checked={plaigarism === 'plagiarised'}
                />
                <span className='text-sm font-normal opacity-60'>
                  Plagiarised submission
                </span>
              </div>

              <div className='text-sm text-gray-400 mt-4'>Feedback</div>
              <textarea
                disabled={true}
                rows='4'
                className='w-full border border-gray-300 focus:outline-none focus:border-blue-c1 focus:ring-1 focus:ring-blue-c1 rounded-lg p-2'
                value={feedbackText}
              />
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
}
